import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Report"],
});

const studentReportApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getStudentReport: builder.mutation({
      query: ({ preview, term_id, classroom_id, template_id, student_id }) => ({
        url: `/report/student`,
        method: "GET",
        params: {
          preview: preview || "html", // default to 'html' if not provided
          term_id,
          classroom_id,
          template_id,
          student_id,
        },
      }),
    }),
    createStudentReport: builder.mutation({
      query: (values) => ({
        url: "/report/student",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Report"],
    }),
    deleteStudentReport: builder.mutation({
      query: (values) => ({
        url: "/report/student",
        method: "DELETE",
        body: { ...values },
      }),
      invalidatesTags: ["Report"],
    }),
    fetchStudentReports: builder.query({
      query: ({ student_id, classroom_id, term_id }) => ({
        url: `/report/student`,
        params: { student_id, classroom_id, term_id },
      }),
      providesTags: ["Report"],
    }),
    getReportStatus: builder.query({
      query: (taskId) => `/report/status/${taskId}`,
      keepUnusedDataFor: 0,
    }),
    cancelReport: builder.mutation({
      query: (taskId) => ({
        url: `/report/cancel/${taskId}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetStudentReportMutation,
  useCreateStudentReportMutation,
  useDeleteStudentReportMutation,
  useLazyFetchStudentReportsQuery,
  useGetReportStatusQuery,
  useCancelReportMutation,
} = studentReportApiSlice;
